import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Alert, Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import NumberInput from '../Input/NumberInput';
import ButtonAction from '../Button.js/SaveButton';
import Loader from '../loader/loader';
import ConfirmDeviceModal from './ConfirmDeviceModal';
import ComboboxImage from '../Input/ComboboxImage';
import crypt from 'src/utils/service/crypt';
import { getGeoLocation } from 'src/hooks/useGetLocation';
import { getPublicIP } from 'src/hooks/useIpWan';
import { generateMixedId } from 'src/utils/formatNumber';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
};
const StyledProductImg = styled('img')({
    // top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    // position: 'absolute',
});
const ChooseCabinetModal = ({
    visible = false,
    setVisible,
    setCancelChooseCabinet = (e) => e,
    setValueCabinet = () => null,
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [cabinet, setcabinet] = useState(null);
    const [dataCabinet, setDataCabinet] = useState([]);

    const [getFlagsCainet, setGetFlagsCainet] = useState(false);
    const getCabinetFlags = useRef();
    const [chooseCabinet, setChooseCabinet] = useState(null);
    const user = useRef({});
    const [infoSession, setInfoSession] = useState({ latitude: 0, longitude: 0, ipWan: 0, deviceId: '' });

    // navigator.permissions.query({ name: 'geolocation' }).then((result) => {
    //     if (result.state === 'denied') {
    //         alert("Bạn đã chặn quyền truy cập vị trí. Hãy bật lại trong cài đặt trình duyệt (ⓘ -> Vị trí).");
    //     }
    // });

    const fetchInfo = async () => {
        if (
            infoSession?.latitude == 0 ||
            infoSession?.longitude == 0 ||
            infoSession?.ipWan == '' ||
            infoSession?.deviceId == ''
        ) {
            let data = { latitude: 0, longitude: 0 };
            let ipWanData = '';

            try {
                data = localStorage.getItem('geo_location');
                if (!data) {
                    data = await getGeoLocation();
                    localStorage.setItem('geo_location', JSON.stringify(data));
                }else{
                    data = JSON.parse(data)
                }
            } catch (err) {
                console.warn('Geo location failed', err);
            }
            try {
                ipWanData = await getPublicIP();
            } catch (err) {
                console.warn('IP fetch failed', err);
            }

            let deviceId = localStorage.getItem('device_id');
            if (!deviceId) {
                deviceId = generateMixedId();
                localStorage.setItem('device_id', deviceId);
            }

            setInfoSession({
                deviceId: deviceId,
                ipWan: ipWanData,
                latitude: data.latitude,
                longitude: data.longitude,
            });
            return {
                deviceId: deviceId,
                ipWan: ipWanData,
                latitude: data.latitude,
                longitude: data.longitude,
            };
        }
    };
    //

    useEffect(() => {
        const start = async () => {
            await fetchInfo();
        };
        start();
    }, []);

    useEffect(() => {
        const userData = sessionStorage.getItem('proc_data');
        if (userData) {
            try {
                const data = JSON.parse(crypt.deCode(userData));
                user.current = data;
            } catch (error) {}
        }
    }, []);

    const handlChoose = async () => {
        if (cabinet) {
            if (glb_sv.getLocalStorageCabinet('cabinet')?.id !== cabinet?.id) {
                await addSessionChangeCabinet(glb_sv.getLocalStorageCabinet('cabinet')?.id || null, cabinet.id);
            }
            console.log('cabinet: ', cabinet);
            setValueCabinet(cabinet);
            glb_sv.setLocalStorageCabinet(cabinet);
            if (user.current?.group_user !== '3') {
                glb_sv.setLocalStorageCabinet(cabinet);
                glb_sv.commonEvent.next({ type: eventList.CHANGE_CABINET, data: true });
            } else {
                sessionStorage.setItem('cabinet', JSON.stringify(cabinet));
                glb_sv.commonEvent.next({ type: eventList.CHANGE_CABINET, data: true });
            }
            setVisible(false);
            setCancelChooseCabinet(true);
        }
    };

    useEffect(() => {
        const chooseCabinetLocal = glb_sv.getLocalStorageCabinet('cabinet');
        if (chooseCabinetLocal) {
            console.log('chooseCabinetLocal:: ', chooseCabinetLocal);

            setChooseCabinet(chooseCabinetLocal);
        }
        setTimeout(() => {
            getDataCabinet();
        }, 1000);
    }, [visible]);

    const addSessionChangeCabinet = async (oldcabinet, newcabinet) => {
        let data = {};
        if (!infoSession.deviceId || !infoSession.ipWan || !infoSession.longitude || !infoSession.latitude) {
            data = await fetchInfo();
        }
        const InVal = [
            infoSession.deviceId || data?.deviceId,
            oldcabinet,
            newcabinet,
            infoSession.ipWan || data?.ipWan,
            infoSession.longitude || data?.longitude,
            infoSession.latitude || data?.latitude,
        ];
        sendRequest(
            serviceList.sessionChangeCabinet,
            InVal,
            addSessionChangeCabinetResult,
            true,
            timeOutFunctCabinet,
            15000
        );
    };

    const addSessionChangeCabinetResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
        }
    };

    const getDataCabinet = useCallback(() => {
        if (getCabinetFlags.current) return;
        getCabinetFlags.current = true;
        setGetFlagsCainet(true);
        const InVal = [];
        sendRequest(serviceList.getAllCabinetSp, InVal, getDataCabinetResult, true, timeOutFunctCabinet, 15000);
    }, []);

    const getDataCabinetResult = (reqInfoMap, message) => {
        getCabinetFlags.current = false;
        setGetFlagsCainet(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const arrCabinet = message.proc_data.rows[0].o_1;
            const filteredCabinet = arrCabinet?.filter((ele) => ele.block_status === '1') || [];
            if (filteredCabinet.length === 0) {
                setVisible(false);
                const menuData = sessionStorage.getItem('menu');
                if (menuData) {
                    try {
                        const menu = JSON.parse(crypt.deCode(menuData));
                        if (menu && menu[0]) {
                            const cabinetMenu = menu[0].find((item) => item.screens_key === 'quan_ly_tu');
                            if (cabinetMenu) {
                                navigate(cabinetMenu.navigate + cabinetMenu.id, { state: { openAdd: true } });
                            }
                        }
                    } catch (error) {
                        console.error('Error parsing menu for redirect', error);
                    }
                }
                return;
            }
            setDataCabinet(filteredCabinet);
            const getCabinetCode = sessionStorage.getItem('cabinetCode');
            if (getCabinetCode) {
                const filterCabinet = arrCabinet.filter((cabin) => cabin.cabinet_cd === getCabinetCode);
                if (filterCabinet?.length > 0) {
                    sessionStorage.setItem('cabinet', JSON.stringify(filterCabinet[0]));
                    setCancelChooseCabinet && setCancelChooseCabinet(true);
                    setVisible(false);
                }
            }
        }
    };
    const timeOutFunctCabinet = (reqInfo) => {
        getCabinetFlags.current = false;
        setGetFlagsCainet(false);
    };
    return (
        <BootstrapDialog fullScreen={fullScreen} open={visible} aria-labelledby="customized-dialog-title">
            <Loader loading={getFlagsCainet} />
            <BootstrapDialogTitle id="customized-dialog-title">{t('choose_cabinet')} </BootstrapDialogTitle>
            <DialogContent dividers>
                {!chooseCabinet && (
                    <Alert sx={{ alignItems: 'flex-start' }} severity="info" style={{ marginBottom: '20px' }}>
                        <div>
                            <Typography fontWeight="lg" sx={{ fontWeight: '600', fontSize: '17px' }} mt={0.25}>
                                {t('note')}
                            </Typography>
                            <Typography fontSize="sm" sx={{ opacity: 0.8 }}>
                                {t('content_choose_cabinet')}
                            </Typography>
                        </div>
                    </Alert>
                )}
                <Grid container spacing={2}>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%', minWidth: '300px' }}>
                        <ComboboxImage
                            onEnterPress={handlChoose}
                            label={t('choose_cabinet')}
                            sizeCbb="medium"
                            //valueSelect={chooseCabinet}
                            valueEqual="id"
                            getValue={setcabinet}
                            displayImage="img_cabinet"
                            selectOption={dataCabinet}
                            displayLabel="cabinet_nm"
                            autoFocus
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    title={t('cancel')}
                    onClick={() => {
                        setVisible(false);
                        setValueCabinet(cabinet);
                        setCancelChooseCabinet && setCancelChooseCabinet(true);
                    }}
                    type="cancel"
                />
                <ButtonAction disabled={!cabinet?.id} onClick={handlChoose} type={'confirm'} title={t('comfirm')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ChooseCabinetModal;
